import { gql } from '@apollo/client';

const DiscountInfo = gql`
  fragment DiscountInfo on Discount {
    id
    code
    target
    discountType
    percentageAmount
    fixedAmount
    expiration
    noExpiration
    createdAt
    updatedAt
  }
`;

export default DiscountInfo;
